import { Navigate } from 'react-router-dom';

const Root = () => {
    return <Navigate to='/dashboard/analytics`} replace '/>;
};

export default Root;
